import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (props: IGenericObject) => {
  const { showSubPrompts } = props;
  const WIDTH_PERCENTAGE = {
    DESCRIPTION: 50,
    SUBJECT: showSubPrompts ? 15 : 0,
    RATING: showSubPrompts ? 35 : 50,
  };
  const options = 5;
  return StyleSheet.create({
    form: {
      width: '100%',
      marginBottom: 45,
      [media.tablet]: {
        width: '100vw',
        margin: `0px calc((-100vw + 100%)/2)`,
        marginBottom: 45,
      },
      [media.desktop]: {
        width: '100%',
        margin: '0px',
        marginBottom: 45,
      },
    },
    required: {
      color: palette.red,
      fontWeight: 'bold',
    },
    fieldDescriptionTitle: {
      fontSize: 16,
      fontWeight: 'bold',

      [media.tablet]: {
        width: '75%',
      },
      [media.desktop]: {
        width: '90%',
      },
    },
    fieldDescriptionTitleRequired: {
      position: 'relative',

      '::before': {
        content: '"*"',
        position: 'absolute',
        left: '-1ch',
        color: palette.red,
      },
    },
    description: {
      width: '100%',
      [children('span')]: {
        display: 'block',
      },
      [children('p')]: {
        fontSize: 16,
        fontWeight: 'bold',
        margin: '25px 0px',
        textAlign: 'center',
      },
      [children(':not(:last-child)')]: {
        marginBottom: 25,
      },
      [media.tablet]: {
        [children('p')]: {
          fontSize: 20,
          padding: ' 0px 20px',
          textAlign: 'left',
        },
      },
      [media.desktop]: {
        [children('p')]: {
          textAlign: 'left',
          padding: ' 20px 65px',
        },
      },
    },
    subsection: {
      [media.smallerThanTablet]: {
        marginBottom: '16px',
      },
    },
    subsectionTitle: {
      width: '100%',
      textAlign: 'center',
      backgroundColor: palette.red,
      padding: '15px 20px',
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        width: '100vw',
        margin: `0px calc((100% - 100vw)/2)`,
      },
    },
    row: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [media.tablet]: {
        padding: '30px ',
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
      [media.desktop]: {
        width: '100%',
        margin: '0px',
      },
    },
    headline: {
      width: '100%',
      padding: '30px 30px',
      display: 'inline-flex',
      alignItems: 'center',
      borderTop: '1px solid red',
      borderBottom: '1px solid red',
      [media.smallerThanTablet]: {
        padding: '0 26px',
        width: '100vw',
        margin: `0px calc((100% - 100vw)/2)`,
      },
    },
    descriptionColumn: {
      width: `${WIDTH_PERCENTAGE.DESCRIPTION}%`,
      display: 'flex',
      flexDirection: 'column',
      fontSize: 16,
      [media.smallerThanTablet]: {
        width: '100%',
        padding: '20px 0',
      },
    },
    tableTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        textAlign: 'center',
      },
    },
    headerSubjectLabel: {
      [media.tablet]: {
        display: 'block',
        width: `${WIDTH_PERCENTAGE.SUBJECT}%`,
      },
      display: 'none',
    },
    headerRatingOption: {
      [media.tablet]: {
        width: `${WIDTH_PERCENTAGE.RATING / options}%`,
        display: 'flex',
        flexDirection: 'column',
        justifyConent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      },
      display: 'none',
    },
    rows: {
      [media.tablet]: {
        ':nth-child(1n) > div:nth-child(2n+1)': {
          backgroundColor: palette.black,
        },
        ':nth-child(1n) > div:nth-child(2n)': {
          backgroundColor: palette.lightDarkGrey,
        },
      },
    },
    subjectRowsContainer: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      [media.tablet]: {
        width: `${WIDTH_PERCENTAGE.SUBJECT + WIDTH_PERCENTAGE.RATING}%`,
      },
    },
    subjectRow: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      [media.tablet]: {
        display: 'inline-flex',
        flexDirection: 'row',
        ':not(:last-child)': {
          marginBottom: 15,
        },
      },
      [media.smallerThanTablet]: {
        paddingTop: 12,
        paddingBottom: 19,
        width: '100vw',
        margin: `0px calc((-100vw + 100%)/2)`,
        ':nth-child(1n)': {
          backgroundColor: '#333333',
        },
        ':nth-child(2n)': {
          backgroundColor: '#4B4B4B',
        },
        ':last-child': {
          borderBottom: '1px solid ' + palette.red,
        },
      },
    },
    subjectCell: {
      [media.tablet]: {
        width: `${(100 * WIDTH_PERCENTAGE.SUBJECT) / (WIDTH_PERCENTAGE.SUBJECT + WIDTH_PERCENTAGE.RATING)}%`,
        flexWrap: 'wrap',
        whiteSpace: 'pre',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
      [media.desktop]: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      },
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      [media.smallerThanTablet]: {
        marginBottom: 18,
        fontWeight: 'bold',
      },
    },
    optionContainer: {
      display: 'inline-flex',
      width: `${(100 * WIDTH_PERCENTAGE.RATING) / (WIDTH_PERCENTAGE.SUBJECT + WIDTH_PERCENTAGE.RATING)}%`,
      padding: '0 20px',
      [media.smallerThanTablet]: {
        width: '100%',
      },
      [media.tablet]: {
        padding: 0,
      },
    },
    optionCell: {
      width: `${100 / options}%`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      [media.smallerThanTablet]: {
        justifyContent: 'space-between',
      },
      [children('> span')]: {
        marginBottom: 5,
        textAlign: 'center',
        [media.tablet]: {
          display: 'none',
        },
      },
    },
  });
};
